<template>
  <div class="product-families-show-layout" v-if="isSuccessfullyLoaded">
    <h1>{{this.productFamily.name}}</h1>

    <ul class="uk-margin-medium-bottom" uk-tab>
      <router-link
        :to="{ name: 'product-family', params: { id: id } }"
        exact-active-class="uk-active"
        tag="li"
      >
        <a>{{$t('tabs.details')}}</a>
      </router-link>

      <router-link
        :to="{ name: 'product-family-compatibilities', params: { id: id } }"
        active-class="uk-active"
        tag="li"
      >
        <a>{{$t('tabs.compatibilities')}}</a>
      </router-link>

      <router-link
        :to="{ name: 'product-family-pxsdb-features', params: { id: id } }"
        active-class="uk-active"
        tag="li"
      >
        <a>{{$t('tabs.pxsdbFeatures')}}</a>
      </router-link>
    </ul>

    <router-view
      :product-family="productFamily"
      @reload-product-family="reloadProductFamily"
    />
  </div>
  <loader v-else />
</template>

<script>
import View from '@/mixins/View';
import productFamilyQuery from '@/api/queries/product-family.graphql';

export default {
  name: 'product-families-show-layout',
  mixins: [View],
  computed: {
    id() {
      return this.$route.params.id;
    },
    breadcrumbs() {
      return [
        {
          key: 'show',
          text: () => this.productFamily.name,
          route: { name: 'product-family', params: { id: this.id } },
          isLoading: !this.isSuccessfullyLoaded,
        },
      ];
    },
    isSuccessfullyLoaded() {
      return this.isLoaded && this.productFamily;
    },
  },
  apollo: {
    productFamily: {
      query: productFamilyQuery,
      variables() {
        return { id: this.id };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      update({ productFamily }) {
        return productFamily;
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  methods: {
    reloadProductFamily() {
      this.$apollo.queries.productFamily.refetch();
    },
  },
  i18n: {
    messages: {
      de: {
        tabs: {
          details: 'Details',
          compatibilities: 'Kompatibilitäten',
          recommendations: 'Empfehlungen',
          pxsdbFeatures: 'PXSDB Features',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ShowLayout.vue?ae2d3b7a